var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "itinerario" },
    [
      _c(
        "RightPanel",
        { attrs: { title: "Itinerario" } },
        [
          [
            _c(
              "div",
              { staticClass: "timeline" },
              [
                _vm.isMinusDay
                  ? _c(
                      "div",
                      { staticClass: "timeline-item" },
                      [
                        _c("ItemDay", { attrs: { value: _vm.startDate } }),
                        _vm._v(" "),
                        _c("ItemVoloAndata")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.days, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "timeline-item" },
                    [
                      _c("ItemDay", { attrs: { value: item.day } }),
                      _vm._v(" "),
                      index === 0
                        ? _c("ItemVoloAndata", {
                            attrs: {
                              "is-destinazione": _vm.isMinusDay,
                              day: item.day
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      index === 0 && _vm.showTrasferimento
                        ? _c("ItemService", {
                            attrs: {
                              "is-trasferimento": true,
                              day: item.day,
                              days: _vm.days
                            },
                            on: { detail: _vm.onServiceDetail }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ItemTourDay", { attrs: { value: item } }),
                      _vm._v(" "),
                      index === _vm.days.length - 1
                        ? _c("ItemVoloRitorno")
                        : _vm._e(),
                      _vm._v(" "),
                      index === _vm.days.length - 1 && _vm.showTrasferimento
                        ? _c("ItemService", {
                            attrs: {
                              "is-trasferimento": true,
                              day: item.day,
                              days: _vm.days
                            },
                            on: { detail: _vm.onServiceDetail }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.isPlusDay
                  ? _c(
                      "div",
                      { staticClass: "timeline-item" },
                      [
                        _c("ItemDay", { attrs: { value: _vm.dayAdded } }),
                        _vm._v(" "),
                        _c("ItemVoloRitorno", {
                          attrs: { "is-destinazione": true }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eaefc3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eaefc3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/tour-accompagnati/ItinerarioTour.vue
// module id = null
// module chunks = 